import { Component } from '@angular/core';
import {HttpClient } from '@angular/common/http'; 
import { AuthService } from '../../_services'; 

@Component({
  selector: 'weighbridgeData',
  templateUrl: './weighbridgeData.component.html',  
})

 export class weighbridgeDataComponent {
 public prjId:any
 public userId:any
  constructor(private HttpClient : HttpClient,private auth : AuthService) { 
  }  
  ngOnInit(){ 
  }

}
 


// WEBPACK FOOTER //
// ./src/app/dataRectify/weighbridgeData/weighbridgeData.component.ts